// src/components/InvoiceView.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./invoice-form.css";

const API_BASE = "https://dairy.server.statify.co.ke";

export default function InvoiceView() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [invoice, setInvoice] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    loadInvoice();
  }, [id]);

  async function loadInvoice() {
    try {
      const res = await fetch(`${API_BASE}/api/sales/${id}`);
      if (!res.ok) {
        throw new Error(`Failed to fetch invoice #${id} (Status: ${res.status})`);
      }

      const data = await res.json();
      setInvoice(data);
      setError("");
    } catch (err) {
      console.error("Error loading invoice:", err);
      setError("Failed to load invoice details. Please check your server connection.");
    }
  }

  if (error) {
    return (
      <div className="modal-overlay">
        <div className="modal">
          <div className="modal-header">
            <h3>Error</h3>
            <button onClick={() => navigate("/invoice-form")} className="btn-close">×</button>
          </div>
          <div className="modal-body">
            <p style={{ color: "red" }}>{error}</p>
          </div>
        </div>
      </div>
    );
  }

  if (!invoice) return <p>Loading...</p>;

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-header">
          <h3>Invoice #{invoice.invoice_number || id}</h3>
          <button onClick={() => navigate("/invoice-form")} className="btn-close">×</button>
        </div>

        <div className="modal-body">
          <p><strong>Customer:</strong> {invoice.buyer_name || "N/A"}</p>
          <p><strong>Total Amount:</strong> {invoice.total_amount?.toFixed(2) || "0.00"}</p>
          <p><strong>Status:</strong> {invoice.payment_status || "Pending"}</p>
          <p><strong>Date:</strong> {invoice.date ? new Date(invoice.date).toLocaleString() : "N/A"}</p>

          {invoice.sale_items && invoice.sale_items.length > 0 && (
            <div style={{ marginTop: "1rem" }}>
              <h4>Invoice Lines</h4>
              <table className="table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Product ID</th>
                    <th>Quantity</th>
                    <th>Unit Price</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {invoice.sale_items.map((line, idx) => (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>{line.product_id}</td>
                      <td>{line.quantity}</td>
                      <td>{line.price_per_unit}</td>
                      <td>{(line.quantity * line.price_per_unit).toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
